import React, { useState } from 'react';
import PropTypes from 'prop-types';

import moTheme from '@ecp/common/src/style/theme/mo';
import { FlexBoxColumn, HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import FullPagePopup from '@ecp/common/src/components/modal/mo/popup/FullPagePopup';
import { VERIFY_TYPE, SEND_VIA } from '@mo-const/member/memberConst';
import RadioGroup from '@ecp/common/src/components/radio/mo/RadioGroup';
import { LabelRadio } from '@ecp/common/src/components/radio/Radio';

import { ReactComponent as TooltipIcon } from '@mo-assets/icon/icon__tooltip_info.svg';

const OtpVerifyPopup = ({ open, onClose, onConfirm, verifyType }) => {

  const [authType, setAuthType] = useState(SEND_VIA.SMS);

  const radioChangeHandler = (e) => {
    if (e.target.value === 'email') {
      setAuthType(SEND_VIA.EMAIL);
    } else {
      setAuthType(SEND_VIA.SMS);
    }
  };

  const handleConfirmClick = () => {
    onConfirm(authType);
  };

  return (
    <FullPagePopup
      open={open}
      header={'2단계 인증'}
      onClose={onClose}
      cancelButtonText={'닫기'}
      onCancelClick={onClose}
      onConfirmClick={handleConfirmClick}
    >
      <FlexBoxColumn width={'100%'} alignItems={'flex-start'}>
        <TextBox width={'100%'} size={moTheme.font.size.$13} weight={moTheme.font.weight.medium2}>
          {verifyType == VERIFY_TYPE.LOGIN_USER && (
            <>
              회원님의 정보를 안전하게 보호하기 위해<br />
              로그인 2단계 인증이 필요합니다. <br />
              인증 방식을 선택하여 2단계 인증을 진행해 주세요.<br />
            </>
          )}
          {verifyType == VERIFY_TYPE.VERIFY_USER && (
            <>
              로그인 2단계 인증이 설정되어 있습니다.<br />
              인증 방식을 선택하여 2단계 인증을 진행해 주세요.<br />
            </>
          )}
        </TextBox>
        <Spacing top={10} />
        <TextBox width={'100%'} size={moTheme.font.size.$12} weight={moTheme.font.weight.demiLight}>
          <TooltipIcon />
          <Spacing left={5} />
          해외 거주자의 경우 이메일로 인증해 주세요.
        </TextBox>
        <Spacing top={20} />
        <HorizontalDivider color="#141415" />
        <Spacing top={20} />
        <FlexBoxColumn width="100%" align-items={'flex-start'}>
          <RadioGroup flex-direction="column" align-items="left" defaultValue="sms" onChange={(e) => radioChangeHandler(e)}>
            <LabelRadio value="sms">SMS</LabelRadio>
            <Spacing top={13} />
            <LabelRadio value="email">이메일</LabelRadio>
          </RadioGroup>
        </FlexBoxColumn>
      </FlexBoxColumn>
    </FullPagePopup>
  );
};

export default OtpVerifyPopup;

OtpVerifyPopup.defaultProps = {
  userInfo: {},
  open: false,
  time: 100,
};

OtpVerifyPopup.propTypes = {
  userInfo: PropTypes.object,
  open: PropTypes.bool,
  update: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  time: PropTypes.number,
  verifyType: PropTypes.string,
  authType: PropTypes.string,
};